import React from "react";

import type { LandingPageContent } from "../content/types";
import { CardVisual } from "./CardVisual";

type ReportsShowcaseProps = {
  content: LandingPageContent["reports"];
};

export function ReportsShowcase({ content }: ReportsShowcaseProps) {
  return (
    <section className="db-section section-band" id={content.id} aria-labelledby={`${content.id}-title`}>
      <div className="db-container">
        <div className="section-heading">
          <p className="section-eyebrow">{content.eyebrow}</p>
          <h2 id={`${content.id}-title`}>{content.title}</h2>
          <p>{content.lead}</p>
        </div>

        <div className="module-showcase">
          {content.modules.map((module) => (
            <article className="module-card module-card--visual" key={module.key}>
              <CardVisual assetId={module.assetId} />
              <div className="module-card__copy">
                <h3>{module.title}</h3>
                <p>{module.body}</p>
              </div>
              <span>{module.detailLabel}</span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
